import React, { forwardRef, useEffect, useRef, useState } from "react";
import BootstrapModal from "react-bootstrap/Modal";
import "./DraggableModal.css";

const DraggableDialog = forwardRef(({ className = "", style, ...props }, ref) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const dragState = useRef(null);

  useEffect(() => {
    const handlePointerMove = (event) => {
      if (!dragState.current) return;

      setPosition({
        x: dragState.current.x + event.clientX - dragState.current.pointerX,
        y: dragState.current.y + event.clientY - dragState.current.pointerY,
      });
    };

    const handlePointerUp = () => {
      dragState.current = null;
      document.body.classList.remove("modal-is-dragging");
    };

    window.addEventListener("pointermove", handlePointerMove);
    window.addEventListener("pointerup", handlePointerUp);

    return () => {
      window.removeEventListener("pointermove", handlePointerMove);
      window.removeEventListener("pointerup", handlePointerUp);
      document.body.classList.remove("modal-is-dragging");
    };
  }, []);

  const handlePointerDown = (event) => {
    const header = event.target.closest(".modal-header");
    const owningDialog = header?.closest(".draggable-modal-dialog");

    if (
      event.button !== 0 ||
      !header ||
      owningDialog !== event.currentTarget ||
      event.target.closest(
        "button, a, input, select, textarea, [data-selectable]"
      )
    ) {
      return;
    }

    event.stopPropagation();
    dragState.current = {
      pointerX: event.clientX,
      pointerY: event.clientY,
      x: position.x,
      y: position.y,
    };
    document.body.classList.add("modal-is-dragging");
    event.preventDefault();
  };

  return (
    <BootstrapModal.Dialog
      {...props}
      ref={ref}
      className={`${className} draggable-modal-dialog`}
      style={{ ...style, transform: `translate(${position.x}px, ${position.y}px)` }}
      onPointerDown={handlePointerDown}
    />
  );
});

const DraggableModal = (props) => (
  <BootstrapModal
    {...props}
    backdrop="static"
    keyboard={false}
    dialogAs={DraggableDialog}
  />
);

DraggableModal.Body = BootstrapModal.Body;
DraggableModal.Footer = BootstrapModal.Footer;
DraggableModal.Header = BootstrapModal.Header;
DraggableModal.Title = BootstrapModal.Title;

export default DraggableModal;